function toggleTab(payload) {
	const parentTab = document.querySelector(payload)
	const tab = parentTab.querySelectorAll('.Tabs__item')
	tab[tab.length - 1].click()
}

;(function reviews() {
	const parent = document.querySelector('.Tabs--product-detailed')
	if (!parent) return

	const reviewsItems = parent.querySelectorAll('.Reviews__list')
	const btn = parent.querySelector('.Reviews__btns > div')

	if (reviewsItems.length > 2) {
		reviewsItems.forEach((item, id) =>
			id >= 2 ? (item.style = 'display: none;') : item,
		)
	}

	btn.onclick = e => {
		e.preventDefault()
		reviewsItems.forEach(item => item.removeAttribute('style'))
		btn.remove()
	}
})()
